import { AfterViewInit, Component, Input, OnChanges, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
    selector: 'app-input-radio-react',
    templateUrl: './input-radio-react.component.html',
    styleUrls: ['./input-radio-react.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputRadioReactComponent),
            multi: true
        }
    ]
})

export class InputRadioReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit {

    public itemSelecionado = null;
    @Input() items: Array<DataModel> = [];

    constructor(
    ) {
        super();
    }
    ngAfterViewInit(): void {
    }

    ngOnInit(): void {
        super.ngOnInit();
        if (this.control && this.control.value) {
            this.itemSelecionado = this.items.find(e => e.id === this.control.value);
        }
        if (this.value) {
            const val = this.value;
            if (this.control) {
                this.control.setValue(val);
                this.valorChange.emit(val);
            }
        }
        this.setAndUpdateValidators();
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }
    selecionar(item: DataModel) {
        this.itemSelecionado = item;

        if (this.control) {
            this.control.setValue(item.id);
        }
        this.valorChange.emit(item.id);

        this.value = item.id;
    }
}
